const ZG_RENTALS_AUTH_REDIRECT_TRACKER = 'ZG_RENTALS_AUTH_REDIRECT_TRACKER';
const redirectAlertInterval = 3 * 60 * 1000; // Three minutes

const AuthRedirectEvent = ({
  loggedIn,
  userToken,
  email,
  hasStrongAuthentication,
  redirectTo,
  time = Date.now(),
  userAgent = navigator.userAgent,
} = {}) => {
  return {
    loggedIn,
    userToken,
    email,
    hasStrongAuthentication,
    redirectTo,
    time,
    userAgent,
  };
};

function trackAuthRedirect({ userToken, loggedIn, email, hasStrongAuthentication, redirectTo }) {
  if (!userToken || !window) {
    // We care most about cases when we know the userId but he is still somehow redirected.
    // If we don't know the userId then most likely he hasn't signed in, and we won't know
    // if it is the same user anyway when we see multiple redirects.
    // We only run this code on client, so we need to make sure window exists
    return;
  }

  let authRedirectTracker = window.sessionStorage.getItem(ZG_RENTALS_AUTH_REDIRECT_TRACKER);
  if (!authRedirectTracker) {
    authRedirectTracker = {};
  } else {
    try {
      authRedirectTracker = JSON.parse(authRedirectTracker);
    } catch {
      // TODO: JSINFRA-1413: Allow consumer to pass in own logger.
      // eslint-disable-next-line no-console
      console.log(`failed to parse ZG_RENTALS_AUTH_REDIRECT_TRACKER from sessionStorage.'`);
    }
  }

  let authRedirectEvents = authRedirectTracker[userToken];

  if (!authRedirectEvents) {
    authRedirectEvents = [];
  }

  authRedirectEvents.push(AuthRedirectEvent({ userToken, loggedIn, email, hasStrongAuthentication, redirectTo }));

  if (authRedirectEvents.length === 4) {
    // We always add to the end of the array and deletes from the beginning, so we make sure
    // their order is sorted.
    const firstEventTime = authRedirectEvents[0].time;
    const lastEventTime = authRedirectEvents[3].time;

    if (lastEventTime - firstEventTime <= redirectAlertInterval) {
      // TODO: JSINFRA-1413: Allow consumer to pass in own logger.
      // eslint-disable-next-line no-console
      console.log('User stuck in an auth loop');
    }

    authRedirectEvents.shift();
  }

  authRedirectTracker[userToken] = authRedirectEvents;

  try {
    window.sessionStorage.setItem(ZG_RENTALS_AUTH_REDIRECT_TRACKER, JSON.stringify(authRedirectTracker));
  } catch {
    // TODO: JSINFRA-1413: Allow consumer to pass in own logger.
    // eslint-disable-next-line no-console
    console.log('failed to stringify ZG_RENTALS_AUTH_REDIRECT_TRACKER and store to sessionStorage');
  }
}

export default trackAuthRedirect;
